import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Button, Input, InputGroup, Select, ToggleLabel } from 'components/FormComponents';

export const IntegrationsSettingsModal = ({
  visible,
  onClose,
  useAuthOnResultFiles,
  onPartnersConfigUpdate,
  useIntegrationUser,
  onUseIntegrationUserChange,
  userId,
  onUserIdChange,
  companyUsers,
  notificationEmails,
  onNotificationEmailsChange,
  onNotificationEmailsBlur,
}) => (
  <AnimatedModal
    visible={visible}
    onClose={onClose}
    noPadding
    title="Settings"
    description="Defaults for connections and notifications from integrated platforms."
    small>
    <div className="flex flex-col">
      <div className="flex flex-col gap-8 mt-4">
        <ToggleLabel
          className="px-6"
          label="Require authentication for viewing result files"
          inputProps={{
            name: 'use_auth_on_result_files',
            checked: useAuthOnResultFiles,
            onChange: onPartnersConfigUpdate,
          }}
        />
        <div className="flex flex-col gap-2 px-6">
          <ToggleLabel
            label="Use integration user"
            tooltip="If disabled, main company user will be used. If launcher user email is provided by partner, it will have presedence over this"
            inputProps={{
              checked: useIntegrationUser,
              onChange: onUseIntegrationUserChange,
            }}
          />
          {useIntegrationUser && (
            <Select name="user_id" value={userId} inputProps={{ onChange: onUserIdChange }}>
              {companyUsers?.map(u => (
                <Select.Item key={u.id} value={u.id}>
                  {u.first_name} {u.last_name} • {u.email}
                </Select.Item>
              ))}
            </Select>
          )}
        </div>
        <InputGroup
          className="px-6"
          title="CC notification emails"
          tooltip="Comma-separated list of emails to CC on all notifications for candidates created through integrations">
          <Input
            inputProps={{
              value: notificationEmails,
              onChange: onNotificationEmailsChange,
              onBlur: onNotificationEmailsBlur,
              placeholder: 'email@example.com, another@example.com',
            }}
            className="u-margin-top--small"
          />
        </InputGroup>
      </div>
      <div className="flex justify-end px-6 py-6 border-t border-neutral-4">
        <Button type="secondary" onClick={onClose}>
          Update settings and close
        </Button>
      </div>
    </div>
  </AnimatedModal>
);
